
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notification-list",
      function () {
        return require("private-next-pages/notification-list/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notification-list"])
      });
    }
  